import { render, staticRenderFns } from "./VeVerticalAlignPicker.vue?vue&type=template&id=ba585522&scoped=true"
import script from "./VeVerticalAlignPicker.vue?vue&type=script&lang=js"
export * from "./VeVerticalAlignPicker.vue?vue&type=script&lang=js"
import style0 from "./VeVerticalAlignPicker.vue?vue&type=style&index=0&id=ba585522&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba585522",
  null
  
)

export default component.exports